/**
 * @generated SignedSource<<02595abe4be4750a238e67d255544203>>
 * @relayHash cf7363cfea249c0b2da1cf11c7c42d39
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e6ffaa25a287e76c421668cfe52d8e9f94b8ae3c13144e889b27b520dc510540

import type { ConcreteRequest, Mutation } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraMultiValueFieldOperations = "ADD" | "REMOVE" | "SET" | "%future added value";
export type JiraUpdateMultipleGroupPickerFieldInput = {
  id: string;
  operations: ReadonlyArray<JiraMultipleGroupPickerFieldOperationInput>;
};
export type JiraMultipleGroupPickerFieldOperationInput = {
  groupIds?: ReadonlyArray<string> | null | undefined;
  ids?: ReadonlyArray<string> | null | undefined;
  operation: JiraMultiValueFieldOperations;
};
export type ui_multiGroupPicker_issueFieldMultiGroupPicker_MultiGroupPickerField_Mutation$variables = {
  input: JiraUpdateMultipleGroupPickerFieldInput;
};
export type ui_multiGroupPicker_issueFieldMultiGroupPicker_MultiGroupPickerField_Mutation$data = {
  readonly jira: {
    readonly updateMultipleGroupPickerField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly " $fragmentSpreads": FragmentRefs<"ui_issueFieldMultiGroupPickerInlineEditFull_MultiGroupPickerInlineEditViewWithIsEditable_fragmentRef">;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type ui_multiGroupPicker_issueFieldMultiGroupPicker_MultiGroupPickerField_Mutation$rawResponse = {
  readonly jira: {
    readonly updateMultipleGroupPickerField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly fieldId: string;
        readonly id: string;
        readonly name: string;
        readonly selectedGroupsConnection: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly groupId: string;
              readonly id: string;
              readonly name: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly type: string;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type ui_multiGroupPicker_issueFieldMultiGroupPicker_MultiGroupPickerField_Mutation = {
  rawResponse: ui_multiGroupPicker_issueFieldMultiGroupPicker_MultiGroupPickerField_Mutation$rawResponse;
  response: ui_multiGroupPicker_issueFieldMultiGroupPicker_MultiGroupPickerField_Mutation$data;
  variables: ui_multiGroupPicker_issueFieldMultiGroupPicker_MultiGroupPickerField_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ui_multiGroupPicker_issueFieldMultiGroupPicker_MultiGroupPickerField_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraMultipleGroupPickerFieldPayload",
            "kind": "LinkedField",
            "name": "updateMultipleGroupPickerField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraMultipleGroupPickerField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "ui_issueFieldMultiGroupPickerInlineEditFull_MultiGroupPickerInlineEditViewWithIsEditable_fragmentRef"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ui_multiGroupPicker_issueFieldMultiGroupPicker_MultiGroupPickerField_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraMultipleGroupPickerFieldPayload",
            "kind": "LinkedField",
            "name": "updateMultipleGroupPickerField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraMultipleGroupPickerField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "fieldId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "type"
                  },
                  {
                    "concreteType": "JiraGroupConnection",
                    "kind": "LinkedField",
                    "name": "selectedGroupsConnection",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraGroupEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraGroup",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v5/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "groupId"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "e6ffaa25a287e76c421668cfe52d8e9f94b8ae3c13144e889b27b520dc510540",
    "metadata": {},
    "name": "ui_multiGroupPicker_issueFieldMultiGroupPicker_MultiGroupPickerField_Mutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "23b63517ce9fe10047fcdf0eced5f652";

export default node;
